import { DateTime } from 'luxon';

import { DispatchTripRead } from 'src/common/external/bambi-api/bambiApi';

export function getDefaultSplitDatetime(
  trips: DispatchTripRead[],
  assignmentId: string
): string {
  const assignmentTrips = trips.filter((t) => t.assignment_id === assignmentId);
  const now = DateTime.now();

  if (!assignmentTrips.length) {
    return now.toFormat("yyyy-MM-dd'T'HH:mm");
  }

  const closest = assignmentTrips.reduce((prev, curr) => {
    const prevDiff = Math.abs(
      DateTime.fromISO(prev.scheduled_dropoff_at).diff(now).milliseconds
    );
    const currDiff = Math.abs(
      DateTime.fromISO(curr.scheduled_dropoff_at).diff(now).milliseconds
    );
    return currDiff < prevDiff ? curr : prev;
  });

  return DateTime.fromISO(closest.scheduled_dropoff_at).toFormat(
    "yyyy-MM-dd'T'HH:mm"
  );
}
